import { render, staticRenderFns } from "./KFDate.vue?vue&type=template&id=078cc4bc&scoped=true&"
import script from "./KFDate.vue?vue&type=script&lang=js&"
export * from "./KFDate.vue?vue&type=script&lang=js&"
import style0 from "./KFDate.vue?vue&type=style&index=0&id=078cc4bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078cc4bc",
  null
  
)

export default component.exports